<template>
  <div v-if="hasConfirmPermission" class="wrapper">
    <button
      :class="[
        'button-aprove',
        status === 0 || status === 2 ? 'text-rose-700' : 'text-gray-400'
      ]"
      @click="
        () => {
          if (status === 0) onUpdateStatus(false)
        }
      "
    >
      <svg
        class="svg-element"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1024 1024"
      >
        <path
          fill="currentColor"
          d="M512 64a448 448 0 1 1 0 896a448 448 0 0 1 0-896m0 393.664L407.936 353.6a38.4 38.4 0 1 0-54.336 54.336L457.664 512L353.6 616.064a38.4 38.4 0 1 0 54.336 54.336L512 566.336L616.064 670.4a38.4 38.4 0 1 0 54.336-54.336L566.336 512L670.4 407.936a38.4 38.4 0 1 0-54.336-54.336z"
        />
      </svg>
    </button>
    <button
      :class="[
        'button-aprove',
        status === 1 || status === 0 ? 'text-green-700' : 'text-gray-400'
      ]"
      @click="
        () => {
          if (status === 0) onUpdateStatus(true)
        }
      "
    >
      <svg
        class="svg-element"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1024 1024"
      >
        <path
          fill="currentColor"
          d="M512 64a448 448 0 1 1 0 896a448 448 0 0 1 0-896m-55.808 536.384l-99.52-99.584a38.4 38.4 0 1 0-54.336 54.336l126.72 126.72a38.27 38.27 0 0 0 54.336 0l262.4-262.464a38.4 38.4 0 1 0-54.272-54.336z"
        />
      </svg>
    </button>
  </div>
</template>
<script>
export default {
  data() {
    return { status: null, hasConfirmPermission: true }
  },
  beforeMount() {
    if (this.params?.value !== null && this.params?.value !== undefined) {
      this.status = this.params.value
    }
    if (
      this.params?.hasConfirmPermission !== null &&
      this.params?.hasConfirmPermission !== undefined
    ) {
      this.hasConfirmPermission = this.params.hasConfirmPermission
    }
  },
  methods: {
    onUpdateStatus(isApproved) {
      this.params.context.componentParent.updateStatus(this.params, isApproved)
    }
  }
}
</script>
<style scoped>
.wrapper {
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  flex-shrink: 0;
  height: 100%;
}
.button-aprove {
  display: flex;
  flex-direction: row;
  gap: 0.25rem;
  align-items: center;
  text-underline-offset: 2px;
}
button {
  background-color: transparent; /* Remove background color */
  border: none; /* Remove border */
  padding: 0; /* Remove padding */
  cursor: pointer;
}
.button-aprove:hover {
  text-underline-offset: 1px;
}
.text-rose-700 {
  color: rgb(190 18 60);
}
.text-rose-400 {
  color: rgb(251 113 133);
}
.text-green-700 {
  color: rgb(21 128 61);
}
.text-gray-400 {
  color: rgb(156 163 175);
}
.svg-element {
  display: block;
  width: 2rem;
  height: 2rem;
}
</style>
